module.exports = __webpack_public_path__ + "static/media/person.thing.c3e392b2.svg";